var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgStarWhite100Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-234.000000, -445.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(208.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(1.073329, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9266707,94.405692 L44.5207198,99.7068979 L40.3807595,93.3675116 L33.9615942,97.3826586 L31.2812046,90.3015145 L24.1489778,92.8428588 L23.0534909,85.3510635 L15.5416977,86.2997746 L16.0823372,78.7476359 L8.54222078,78.0593533 L10.693707,70.8000009 L3.4778347,68.5069078 L7.13956653,61.879781 L0.585344565,58.0890998 L5.5861035,52.4040757 L-4.57411886e-14,47.2930546 L6.10595611,42.8159585 L1.74917107,36.6235831 L8.67481663,33.5637591 L5.75106847,26.579578 L13.172568,25.0801 L11.8185679,17.6306858 L19.3889004,17.7616678 L19.6679599,10.1953467 L27.0331449,11.9506642 L28.9322156,4.62122902 L35.7478653,7.91880519 L39.1781487,1.16897221 L45.1255709,5.8546161 L49.9266707,7.10542736e-15 L54.7277705,5.8546161 L60.6751927,1.16897221 L64.1054761,7.91880519 L70.9211258,4.62122902 L72.8201965,11.9506642 L80.1853815,10.1953467 L80.464441,17.7616678 L88.0347734,17.6306858 L86.6807734,25.0801 L94.1022729,26.579578 L91.1785248,33.5637591 L98.1041703,36.6235831 L93.7473853,42.8159585 L99.8533414,47.2930546 L94.2672379,52.4040757 L99.2679968,58.0890998 L92.7137749,61.879781 L96.3755067,68.5069078 L89.1596344,70.8000009 L91.3111206,78.0593533 L83.7710041,78.7476359 L84.3116436,86.2997746 L76.7998505,85.3510635 L75.7043636,92.8428588 L68.5721368,90.3015145 L65.8917472,97.3826586 L59.4725818,93.3675116 L55.3326216,99.7068979 L49.9266707,94.405692 Z M49.9266707,92 C73.1226302,92 91.9266707,73.1959595 91.9266707,50 C91.9266707,26.8040405 73.1226302,8 49.9266707,8 C26.7307112,8 7.92667069,26.8040405 7.92667069,50 C7.92667069,73.1959595 26.7307112,92 49.9266707,92 Z",
    id: "Combined-Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStarWhite100Px);
export default __webpack_public_path__ + "static/media/BG_Star_White-100px.7c55ebdb60ba4a1f5f63bb10045fc10a.svg";
export { ForwardRef as ReactComponent };